var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    workbench-sequence-waggon-tab
    ${_vm.color}
    ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}
    ${_vm.selected?`tab-selected`:'tab-non-selected'}
    `,style:(`width: ${_vm.width}; color: ${_vm.text_color} !important`)},[_c('TIcon',{staticClass:"cursor-pointer",attrs:{"name":_vm.getNewIcon(_vm.icon),"color":_vm.text_color?_vm.text_color:'black'}}),_c('div',{staticClass:"ml-1 workbench-sequence-waggon-tab-content"},[_vm._t("content")],2),_c('v-spacer'),_c('div',{staticClass:"mr-1 workbench-sequence-waggon-tab-actions"},[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }